import { Snackbar, SnackbarContent } from "@mui/material";
import colorsConstants from "src/app/constants/colors.constants";
import SnackbarModel from "src/app/models/components/snackbar.model";

const SnackBarComponentView: React.FC<SnackbarModel> = (
  snackbarProps: SnackbarModel,
) => {
  const { isError, message, duration, isOpen, onClose } = snackbarProps;
  return (
    <Snackbar
      autoHideDuration={duration ?? 5000}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      open={isOpen}
      onClose={onClose}
    >
      <SnackbarContent
        message={message}
        sx={{
          backgroundColor: isError
            ? colorsConstants.error
            : colorsConstants.success,
          color: colorsConstants.snackbarTextColor,
          fontWeight: 500,
        }}
      />
    </Snackbar>
  );
};

export default SnackBarComponentView;
